import Home from './Home';

export default Home;


// WEBPACK FOOTER //
// ./src/pages/home/index.js